/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 */

import type { Listable, Pin, Property } from '@zcode/state-type'

export const isVerified = (t: Listable | Pin | Property) =>
  !!t.isActive && (!!t.isDirectDeal || !!t.isBoosted || !!t.isInstantApplyScreening)
